/*
 * av-mag-more.js
 * ---------------------------------------------------------------------------
 * „Weitere Stories laden" im Magazin-Raster.
 *
 * Der Knopf zeigt serverseitig auf die nächste Seite und funktioniert dadurch
 * auch ohne JavaScript. Ist das Skript da, wird die nächste Seite über die
 * Section Rendering API geholt und ans bestehende Raster angehängt — die Seite
 * springt nicht, die Scrollposition bleibt stehen.
 *
 * Der Zustand steht in den data-Attributen des Containers, nicht im Skript.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var CONTAINER = '[data-av-mag-more]';
  var BUTTON = '[data-av-mag-more-btn]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function num(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  /* Styles und Skripte aus dem Fragment werfen — die stehen durch die erste
     Seite längst im Dokument. */
  function strip(node) {
    toArray(node.querySelectorAll('style, link[rel="stylesheet"], script')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    return node;
  }

  function buildUrl(sectionId, page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function targetList(container) {
    var section = container.closest('.av-mag-grid') || document;
    return section.querySelector('[data-av-mag-list]');
  }

  function load(container, button) {
    if (container.getAttribute('data-av-busy') === 'true') return;

    var sectionId = container.getAttribute('data-section-id');
    var page = num(container, 'data-current-page', 1) + 1;
    var totalPages = num(container, 'data-total-pages', 1);
    var list = targetList(container);

    if (!sectionId || !list || page > totalPages) return;

    container.setAttribute('data-av-busy', 'true');
    var label = button ? button.textContent : '';
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Stories werden geladen …';
    }

    fetch(buildUrl(sectionId, page), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-av-mag-list]');
        if (!incoming) throw new Error('Kein Raster im Fragment');

        toArray(incoming.children).forEach(function (item) {
          list.appendChild(strip(item));
        });

        container.setAttribute('data-current-page', String(page));

        /* Auf der letzten Seite hat der Knopf sein Ziel verloren. */
        if (page >= totalPages) {
          if (button && button.parentNode) button.parentNode.removeChild(button);
        } else if (button) {
          var next = new URL(window.location.href);
          next.searchParams.set('page', String(page + 1));
          button.setAttribute('href', next.toString());
          button.textContent = label;
        }

        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          try {
            window.initializeScrollAnimationTrigger(list);
          } catch (e) {
            /* noop */
          }
        }

        document.dispatchEvent(
          new CustomEvent('av:mag-more:appended', { detail: { page: page } })
        );
      })
      .catch(function (error) {
        console.warn('[av-mag-more] Nachladen fehlgeschlagen:', error);
        /* Der Knopf behält sein href — ein Klick führt dann wie früher auf die
           nächste Seite, statt ins Leere zu laufen. */
        if (button) {
          button.textContent = label;
          button.removeAttribute('data-av-mag-more-btn');
        }
      })
      .then(function () {
        container.removeAttribute('data-av-busy');
        if (button) button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(BUTTON) : null;
    if (!button) return;
    var container = button.closest(CONTAINER);
    if (!container) return;
    event.preventDefault();
    load(container, button);
  });
})();
